import {
  HiOutlineHome,
  HiOutlineBuildingOffice2,
  HiOutlineChartBar,
  HiOutlineDocumentText,
  HiOutlineLightBulb,
  HiOutlineMagnifyingGlass,
  HiOutlineBookOpen,
  HiOutlineUsers,
  HiOutlineClock,
  HiOutlineClipboardDocumentList,
  HiOutlineDocument,
  HiOutlineFolder,
  HiOutlineCheckCircle,
  HiOutlineBell,
  HiOutlinePauseCircle,
  HiOutlineChartPie,
  HiOutlinePaperClip,
  HiOutlineArrowTrendingUp,
  HiOutlineClipboardDocumentCheck,
  HiOutlineExclamationTriangle,
  HiOutlineExclamationCircle,
  HiOutlineLockClosed,
  HiOutlineArrowDownTray,
  HiOutlineWrench,
  HiOutlinePuzzlePiece,
  HiOutlineShieldCheck,
  HiOutlineMap,
  HiOutlineComputerDesktop,
  HiOutlineSquares2X2,
  HiOutlineCurrencyDollar,
  HiOutlineCalendarDays,
  HiOutlineCog,
  HiOutlineCube,
  HiOutlineEye,
  HiOutlineShieldExclamation,
  HiOutlineDocumentCheck,
  HiOutlineArchiveBox,
} from "react-icons/hi2";

export const MAIN_MENU_ITEMS_RAW = [
  {
    path: "/home",
    icon: HiOutlineHome,
    label: "Home",
    key: "dashboard",
    permissionCode: "Dashboard.View",
    keywords: ["landing"],
  },
  {
    path: "/home/dashboard",
    icon: HiOutlineChartBar,
    label: "Dashboard",
    key: "role-dashboard",
    permissionCode: null,
  },
  {
    path: "/home/bi-dashboard",
    icon: HiOutlineChartBar,
    label: "BI Dashboard",
    key: "bi-dashboard",
  },
  {
    path: "/home/work-order",
    icon: HiOutlineClipboardDocumentCheck,
    label: "Work Orders",
    key: "work-order",
    keywords: ["wo", "work order"],
  },
  {
    path: "/home/kaizen",
    icon: HiOutlineLightBulb,
    label: "Kaizen",
    key: "kaizen",
    permissionCode: "Kaizen.View",
    keywords: ["improvement", "ideas", "suggestion", "continuous improvement", "kaizen"],
  },
  {
    path: "/home/fives",
    icon: HiOutlineCheckCircle,
    label: "Quality / 5S Audit",
    key: "fives",
    permissionCode: "Quality_5S.View",
    keywords: ["audit", "compliance", "inspection", "quality", "cleanliness", "fives", "5s"],
  },
  {
    path: "/home/opl",
    icon: HiOutlineBookOpen,
    label: "OPL Documents",
    key: "opl",
  },
  {
    path: "/home/flowchart",
    icon: HiOutlineMap,
    label: "Smart Flowchart",
    key: "flowchart",
  },
];

export const SETTINGS_MENU_ITEMS_RAW = [
  {
    path: "/home/settings/general",
    icon: HiOutlineCog,
    label: "General Settings",
    key: "general-settings",
  },
  {
    path: "/home/settings/company",
    icon: HiOutlineBuildingOffice2,
    label: "Company",
    key: "company",
    permissionCode: "Tenant.Manage",
  },
  {
    path: "/home/settings/change-password",
    icon: HiOutlineLockClosed,
    label: "Change Password",
    key: "change-password",
  },
  {
    path: "/home/settings/master-data-import",
    icon: HiOutlineArrowDownTray,
    label: "Import Master Data",
    key: "master-data-import",
    permissionCode: "ExcelImport.Import",
  },
  {
    path: "/home/settings/departments",
    icon: HiOutlineBuildingOffice2,
    label: "Departments",
    key: "departments",
  },
  {
    path: "/home/settings/areas",
    icon: HiOutlineMap,
    label: "Areas",
    key: "areas",
  },
  {
    path: "/home/settings/site-layout",
    icon: HiOutlineMap,
    label: "Site Layout",
    key: "settings-site-layout",
  },
  {
    path: "/home/settings/products",
    icon: HiOutlineCube,
    label: "Products",
    key: "products",
  },
  {
    path: "/home/settings/product-skus",
    icon: HiOutlineCube,
    label: "SKU Master",
    key: "product-skus",
  },
  {
    path: "/home/settings/shifts",
    icon: HiOutlineClock,
    label: "Shifts",
    key: "shifts",
  },
  {
    path: "/home/settings/roles",
    icon: HiOutlineUsers,
    label: "Roles",
    key: "roles",
  },
  {
    path: "/home/settings/permissions",
    icon: HiOutlineLockClosed,
    label: "Permissions",
    key: "permissions",
  },
  {
    path: "/home/settings/loss-types",
    icon: HiOutlineClipboardDocumentList,
    label: "Loss Types",
    key: "loss-types",
  },
  {
    path: "/home/settings/loss-subtypes",
    icon: HiOutlineDocument,
    label: "Loss Sub Types",
    key: "loss-subtypes",
  },
  {
    path: "/home/settings/categories",
    icon: HiOutlineFolder,
    label: "Categories",
    key: "categories",
  },
  {
    path: "/home/settings/statuses",
    icon: HiOutlineCheckCircle,
    label: "Statuses",
    key: "statuses",
  },
  {
    path: "/home/settings/triggers",
    icon: HiOutlineBell,
    label: "Triggers",
    key: "triggers",
  },
  {
    path: "/home/settings/cycle-times",
    icon: HiOutlineClock,
    label: "Cycle Times",
    key: "cycle-times",
  },
  {
    path: "/home/settings/planned-downtimes",
    icon: HiOutlinePauseCircle,
    label: "Planned Downtimes",
    key: "planned-downtimes",
  },
  {
    path: "/home/settings/oee-thresholds",
    icon: HiOutlineChartPie,
    label: "OEE Thresholds",
    key: "oee-thresholds",
  },
  {
    path: "/home/settings/attachment-types",
    icon: HiOutlinePaperClip,
    label: "Attachment Types",
    key: "attachment-types",
  },
  {
    path: "/home/settings/impact-levels",
    icon: HiOutlineArrowTrendingUp,
    label: "Impact Levels",
    key: "impact-levels",
  },
  {
    path: "/home/settings/ppe-list",
    icon: HiOutlineShieldCheck,
    label: "PPE List",
    key: "ppe-list",
  },
  {
    path: "/home/settings/pm-masters",
    icon: HiOutlineClipboardDocumentCheck,
    label: "PM Masters",
    key: "pm-masters",
  },
  {
    path: "/home/settings/contractor-masters",
    icon: HiOutlineUsers,
    label: "Contractor Masters",
    key: "contractor-masters",
    permissionCode: "Contractor.View",
  },
  {
    path: "/home/plants",
    icon: HiOutlineBuildingOffice2,
    label: "Plants",
    key: "plants",
  },
  {
    path: "/home/asset-master",
    icon: HiOutlineSquares2X2,
    label: "Asset Master",
    key: "asset-master",
  },
  {
    path: "/home/users",
    icon: HiOutlineUsers,
    label: "Users",
    key: "users",
  },
];

export const OEE_MENU_ITEMS_RAW = [
  {
    path: "/home/oee",
    icon: HiOutlineComputerDesktop,
    label: "Production & Downtime (OEE)",
    key: "oee-dashboard",
    permissionCode: "OEE.View",
  },
  {
    path: "/home/breakdown-log",
    icon: HiOutlineExclamationTriangle,
    label: "Breakdown Log",
    key: "breakdown-log",
    permissionCode: "OEE.View",
  },
  {
    path: "/home/loss-reasons",
    icon: HiOutlineClipboardDocumentList,
    label: "Loss Reasons",
    key: "loss-reasons",
    permissionCode: "OEE.View",
  },
  {
    path: "/home/oee/settings",
    icon: HiOutlineCog,
    label: "OEE Settings",
    key: "oee-settings",
    permissionCode: "OEE.View",
  },
];

export const SPARE_PARTS_INVENTORY_MENU_ITEMS_RAW = [
  {
    path: "/home/spare-parts",
    icon: HiOutlineChartBar,
    label: "Spares & Inventory",
    key: "spare-parts",
    permissionCode: "SpareInventory.View",
  },
  {
    path: "/home/inventory/dashboard",
    icon: HiOutlineChartBar,
    label: "Inventory Dashboard",
    key: "inventory-dashboard",
    permissionCode: "SpareInventory.View",
  },
  {
    path: "/home/inventory/history",
    icon: HiOutlineClipboardDocumentList,
    label: "Inventory History",
    key: "inventory-history",
    permissionCode: "SpareInventory.View",
  },
];

export const RCA_MENU_ITEMS_RAW = [
  {
    path: "/home/rca",
    icon: HiOutlineMagnifyingGlass,
    label: "5Why & Root Cause Analysis",
    key: "rca-records",
    permissionCode: "RCA.View",
  },
  {
    path: "/home/rca/five-whys",
    icon: HiOutlineDocumentText,
    label: "5 Whys Analysis",
    key: "five-whys",
    permissionCode: "RCA.View",
  },
  {
    path: "/home/settings/root-cause-categories",
    icon: HiOutlinePuzzlePiece,
    label: "Root Cause Categories",
    key: "root-cause-categories",
    permissionCode: "RCA.View",
  },
  {
    path: "/home/settings/failure-modes",
    icon: HiOutlineExclamationCircle,
    label: "Failure Modes",
    key: "failure-modes",
    permissionCode: "RCA.View",
  },
];

export const CAPA_MENU_ITEMS_RAW = [
  {
    path: "/home/capa",
    icon: HiOutlineClipboardDocumentCheck,
    label: "CAPA Management",
    key: "capa-records",
    permissionCode: "CAPA.View",
  },
  {
    path: "/home/capa/task-management",
    icon: HiOutlineCheckCircle,
    label: "Task Management",
    key: "task-management",
    permissionCode: "CAPA.View",
  },
];

export const SAFETY_OBSERVATION_MENU_ITEMS_RAW = [
  {
    path: "/home/safety-observation/schedule",
    icon: HiOutlineEye,
    label: "Safety Observation",
    key: "safety-observation-schedule",
    permissionCode: "SafetyObservation.View",
  },
  {
    path: "/home/settings/safety-behavior-categories",
    icon: HiOutlineShieldCheck,
    label: "Safety Behavior Categories",
    key: "safety-behavior-categories",
    permissionCode: "SafetyObservation.View",
  },
];

export const INCIDENT_MENU_ITEMS_RAW = [
  {
    path: "/home/incident/analytics",
    icon: HiOutlineShieldExclamation,
    label: "Incident Management",
    key: "incident-analytics",
    permissionCode: "Incident.View",
  },
  {
    path: "/home/incident/dashboard",
    icon: HiOutlineClipboardDocumentList,
    label: "Incident Summary",
    key: "incident-summary",
    permissionCode: "Incident.View",
  },
  {
    path: "/home/incident/new",
    icon: HiOutlineExclamationTriangle,
    label: "Report New Incident",
    key: "incident-new",
    permissionCode: "Incident.View",
  },
];

export const HAZARD_MENU_ITEMS_RAW = [
  {
    path: "/home/hazard-reports",
    icon: HiOutlineClipboardDocumentList,
    label: "Hazard Log",
    key: "hazard-summary",
    permissionCode: "Hazard.View",
  },
  {
    path: "/home/hazard-reports/analytics",
    icon: HiOutlineExclamationTriangle,
    label: "Hazard Analytics",
    key: "hazard-analytics",
    permissionCode: "Hazard.View",
  },
  {
    path: "/home/Hazard-Reporting/hazard-categories",
    icon: HiOutlineExclamationTriangle,
    label: "Hazard Categories",
    key: "hazard-categories",
    permissionCode: "Hazard.View",
  },
];

export const REPORTS_DETAIL_ITEMS_RAW = [
  {
    path: "/home/reports/oee-financial-loss",
    icon: HiOutlineCurrencyDollar,
    label: "Financial Loss Report",
    key: "financial-loss-report",
    permissionCode: "Reports.View",
  },
  {
    path: "/home/reports/sku-performance",
    icon: HiOutlineCube,
    label: "SKU Performance",
    key: "sku-performance-report",
    permissionCode: "Reports.View",
  },
  {
    path: "/home/reports/mtbr",
    icon: HiOutlineDocumentText,
    label: "MTBR Report",
    key: "mtbr-report",
    permissionCode: "Reports.View",
  },
  {
    path: "/home/reports/mtbf",
    icon: HiOutlineDocumentText,
    label: "MTBF Report",
    key: "mtbf-report",
    permissionCode: "Reports.View",
  },
  {
    path: "/home/reports/pm-schedule-compliance",
    icon: HiOutlineDocumentText,
    label: "PM Schedule Compliance",
    key: "pm-schedule-compliance",
    permissionCode: "Reports.View",
  },
  {
    path: "/home/reports/pm-overdue",
    icon: HiOutlineDocumentText,
    label: "PM Overdue",
    key: "pm-overdue-report",
    permissionCode: "Reports.View",
  },
];

export const PM_MENU_ITEMS_RAW = [
  {
    path: "/home/pm",
    icon: HiOutlineWrench,
    label: "Machine Health",
    key: "pm-hub",
    permissionCode: "PlannedMaintenance.View",
    keywords: ["planned maintenance", "pm hub", "machine health"],
  },
  {
    path: "/home/pm/operator-tasks",
    icon: HiOutlineClipboardDocumentCheck,
    label: "My PM Tasks",
    key: "pm-operator-tasks",
    permissionCode: "PlannedMaintenance.View",
  },
  {
    path: "/home/pm/calendar",
    icon: HiOutlineCalendarDays,
    label: "PM Calendar",
    key: "pm-calendar",
    permissionCode: "PlannedMaintenance.View",
  },
  {
    path: "/home/settings/pm-masters/pmStandards",
    icon: HiOutlineClipboardDocumentList,
    label: "PM Standards",
    key: "pm-standards",
    permissionCode: "PlannedMaintenance.View",
  },
];

export const WORK_PERMIT_MENU_ITEMS_RAW = [
  {
    path: "/home/work-permits/dashboard",
    icon: HiOutlineDocumentCheck,
    label: "Work Permits (PTW)",
    key: "wp-dashboard",
    permissionCode: "WorkPermit.View",
  },
  {
    path: "/home/work-permits",
    icon: HiOutlineClipboardDocumentCheck,
    label: "Permit List",
    key: "wp-list",
    permissionCode: "WorkPermit.View",
  },
  {
    path: "/home/work-permits/reports/expiring",
    icon: HiOutlineExclamationTriangle,
    label: "Expiring Report",
    key: "wp-report-expiring",
    permissionCode: "WorkPermit.View",
  },
  {
    path: "/home/work-permits/reports/status",
    icon: HiOutlineDocumentText,
    label: "Status Report",
    key: "wp-report-status",
    permissionCode: "WorkPermit.View",
  },
  {
    path: "/home/work-permits/reports/compliance",
    icon: HiOutlineCheckCircle,
    label: "Compliance Report",
    key: "wp-report-compliance",
    permissionCode: "WorkPermit.View",
  },
];
